(function () {
    'use strict';

    angular
        .module('app')
        .component('tourMemberSection', {
            templateUrl: 'components/directives/tour_member_section/view.tour_member_section.html',
            controller: ['$scope', '$http', '$q', '$log', 'dialog', TourCardController],
            bindings: {
                tours: '<',
                upcomingConcerts: '<',
                onUpdate: '&',
                onDelete: '&'
            }
        });


    function TourCardController($scope, $http, $q, $log, dialog) {
        const ctrl = this;
        ctrl.actionToggle = null;
        ctrl.tours = null;
        ctrl.deleteTourPopup = deleteTourPopup;
        ctrl.updateConcert = updateConcert;
        ctrl.updateTourPopup = updateTourPopup;
        ctrl.updateTour = updateTour;

        async function deleteTour(tourId) {
            $log.debug('Tours before', ctrl.tours.length);
            const response = await $q.when($http.delete('api/users/private/tours/' + tourId));
            $scope.$applyAsync(() => {
                const idx = ctrl.tours.findIndex(t => t.id === tourId);
                ctrl.tours = [
                    ...ctrl.tours.slice(0, idx),
                    ...ctrl.tours.slice(idx + 1),
                ];
                $log.debug('Tours after', ctrl.tours.length);
            })
            ctrl.onDelete();
        }

        async function deleteTourPopup(tour) {
            ctrl.actionToggle = null;
            const result = await $q.when(dialog.prompt('delete_tour_prompt', null, false, false, { tourName: tour.name }));
            if (result.confirm) {
                deleteTour(tour.id);
            }
        }

        function updateConcert(concertId) {
            $log.debug('Concert updated in tour section', concertId);
            ctrl.onUpdate();
        }
        
        function updateTourPopup(tour) {
            ctrl.actionToggle = null;
            ctrl.showEditTour = tour;
        }
        
        function updateTour() {
            ctrl.showEditTour = null;
            ctrl.onUpdate();
        }
    }
})();